import React, { Fragment } from "react";
import TopBox from "../common/TopBox";
import SectionList from "../sections/SectionList";
import FullImageIntro from "../common/FullImageIntro";
import { ApiResult } from "../../lib/CmsApi";
import CategoryTeaser from "./CategoryTeaser";
import InfoBox from "../common/TopBox/InfoBox";
import Contacts from "../sections/Contacts";
import { colors } from "../theme";
import Section from "../sections/Section";
import MagazineTeaserSection from "../sections/MagazineTeaserSection";
import { sortByPositionField } from "../../lib/sort";
import EventSliderSection from "../sections/EventSlider";

type CategoryCluster = ApiResult<"loadCategoryClusterBySlug">;
type Events = ApiResult<"listExternalEvents">["items"];

export type Props = CategoryCluster & {
  events: Events;

  portraits: ApiResult<"listMagazinPortraits">;
  news: ApiResult<"listMagazinNews">;
};
export default function CategoryClusterPage(props: Props) {
  const categories = props.categories
    ? sortByPositionField(props.categories)
    : [];
  return (
    <Fragment>
      <TopBox
        breadCrumpPath={[
          {
            title: props.segment.name,
            route: "segment",
            params: { segment: props.segment.slug }
          },
          {
            title: props.name,
            route: "categoryCluster",
            params: { segment: props.segment.slug, categoryCluster: props.slug }
          }
        ]}
        subLinks={
          props.categories
            ? categories.map(cat => ({
                title: cat.name,
                route: "category",
                params: {
                  category: cat.slug,
                  categoryCluster: props.slug,
                  segment: props.segment.slug
                }
              }))
            : undefined
        }
        title={props.name}
        infoBox={
          props.infoBox &&
          props.infoBox.showBox &&
          "title" in props.infoBox &&
          props.infoBox.title ? (
            <InfoBox title={props.infoBox.title as string} {...props.infoBox} />
          ) : (
            undefined
          )
        }
        infoBoxTop
        infoBoxBlock
      />
      <main>
        {props.header && (
          <FullImageIntro
            image={props.header.image}
            icon={props.header.icon}
            fallBackAlt={props.header.headline}
            headline={props.header.headline}
            intro={props.header.intro}
          />
        )}
        {props.categories &&
          categories.map((cat, key) => (
            <Section noTopPadding key={key}>
              <CategoryTeaser
                category={cat}
                categorySlug={props.slug}
                segmentSlug={props.segment.slug}
              />
            </Section>
          ))}
        {props.events.length > 0 && (
          <EventSliderSection
            events={props.events}
            sectionProps={{ noTopPadding: true }}
          />
        )}
        <SectionList sections={props.contents} />
        {props.contacts && props.contacts.length > 0 && (
          <Contacts
            sectionProps={{ color: colors.anotherblue }}
            contacts={props.contacts}
            headline="Wir sind für Sie da:"
            copy={`Wir beantworten Ihnen gerne Fragen zur Förderung für den Bereich „${props.name}“ und informieren Sie über die Angebote der IFB Hamburg.`}
            ariaLabel={`Ansprechpartner für den Bereich ${props.name}`}
          />
        )}
      </main>
      <aside>
        <MagazineTeaserSection
          overline={props.name}
          portraits={props.portraits}
          news={props.news}
        />
      </aside>
    </Fragment>
  ); //TODO: FIX Type
}

CategoryClusterPage.getImages = (props: Props) => {
  let images = [];
  if (props.header) {
    images = images.concat(FullImageIntro.getImages(props.header));
  }
  images = images.concat(SectionList.getImages({ sections: props.contents }));
  images = images.concat(Contacts.getImages({ contacts: props.contacts }));
  images = images.concat(
    MagazineTeaserSection.getImages({
      portraits: props.portraits,
      news: props.news
    })
  );
  return images;
};
